import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { DirectReportAPIData, transformDirectReport, transformUserDetail, UserDetailAPIData } from '../types/user';

/**
 * @deprecated
 */
export const useUser = (id?: string) => {
	const http = useHttpClient();

	return useQuery({
		enabled: !!id,
		queryKey: ['user', id],
		queryFn: async () => {
			const res = await http.get<UserDetailAPIData>(`/user_management/users/${id}`);
			return transformUserDetail(res.data);
		},
	});
};

/**
 * @deprecated
 */
export const useUserIncludeDeactivated = (id?: string) => {
	const http = useHttpClient();

	return useQuery({
		enabled: !!id,
		queryKey: ['user-include-deactivated', id],
		queryFn: async () => {
			const res = await http.get<UserDetailAPIData>(`/user_management/users/${id}/active_or_deactivated`);
			return transformUserDetail(res.data);
		},
	});
};

/**
 * @deprecated
 */
export const useUsers = (ids?: string[]) => {
	const http = useHttpClient();

	return useQuery({
		enabled: !!ids,
		queryKey: ['user', ids],
		queryFn: async () => {
			if (!ids) {
				return [];
			}

			const sliceSize = 1000;

			const slices = ids.reduce((resultArray, item, index) => {
				const sliceIndex = Math.floor(index / sliceSize);
				if (!resultArray[sliceIndex]) {
					resultArray[sliceIndex] = [];
				}

				resultArray[sliceIndex].push(item);
				return resultArray;
			}, [] as string[][]);

			const requests = slices.map((slice) => {
				return http.post<UserDetailAPIData[]>('/user_management/users/bulk', {
					user_ids: slice,
				});
			});

			const promisesResult = await Promise.all(requests);

			const result = promisesResult.flatMap((res) => {
				return res.data;
			});

			return result.map(transformUserDetail);
		},
	});
};

type DirectReportsApiResponse = {
	data: {
		users: DirectReportAPIData[];
	};
};

/**
 * @deprecated
 */
export const useDirectReports = (userId: string) => {
	const http = useHttpClient('v1');

	return useQuery({
		queryKey: ['direct-reports', userId],
		queryFn: async () => {
			const res = await http.get<DirectReportsApiResponse>(`/users/${userId}/direct_reports.json`);
			return res.data.data.users.map(transformDirectReport);
		},
	});
};
